var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_vm._m(0),_c('div',{ref:"orderTypeStatisticsChart",staticStyle:{"height":"300px","width":"100%"}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-flex"},[_c('div',{staticClass:"icon"}),_c('div',[_vm._v("订单类型统计")])])
}]

export { render, staticRenderFns }